import classNames from 'classnames';
import React, { CSSProperties, ReactNode } from 'react';

import styles from './round-icon-container.module.scss';

interface Props {
  borderColor?: CSSProperties['borderColor'];
  color: CSSProperties['color'];
  children: ReactNode;
  size: number;
}

const RoundIconContainer: React.FC<Props> = ({
  borderColor,
  color,
  children,
  size,
}) => (
  <div
    className={classNames(styles.container, {
      [styles.medium]: size < 36,
      [styles.large]: size >= 36,
    })}
    style={{
      backgroundColor: color,
      border: borderColor ? `1px solid ${borderColor}` : null,
    }}
  >
    {children}
  </div>
);

export default RoundIconContainer;
